module.exports = __webpack_public_path__ + "static/media/move-left.87529cfe.png";